import {useState, useEffect} from 'react'
import {differenceWith, isEmpty,} from 'lodash'
import React from 'react'
import {useSelector, useDispatch} from 'react-redux'
import CustomButton from 'components/CustomButton'
import Chip from 'components/form/Chip'
import {changeTimeSlotStatus, getCampaignInfo, getShifts} from 'redux/slices/nurseCampaignSlice'
import LabeledSelect from "../../../components/selects/LabeledSelect";
import JobCardLoader from "./JobCardLoader";
import {utcToLocalTimeString} from "../../../helpers/dateTimeHelper";
import FormLabel from "../../../components/form/FormLabel";
import CustomMessage from "../../../components/CustomMessage";

const BookTimeSlot = (props) => {
  const [selectedDate, setSelectedDate] = useState('')
  const [selectedShift, setSelectedShift] = useState('')

  const {
    shiftList, disabledShift, campaignInfo, loadingCampaignInfo, campaignInfoError, shiftListError, loadingShiftList
  } = useSelector((state) => state.campaign,)

  const dispatch = useDispatch()

  useEffect(() => {
    setSelectedDate('');
    setSelectedShift('')
  }, [disabledShift])

  const onSlotBook = (status, bookedSlot = {}) => {
    let payload
    if (status) {
      payload = {
        date: selectedDate.value, shift_id: selectedShift.id, full: true, campaign_id: props.campaignId,
      }
    } else {
      payload = {
        date: bookedSlot?.date, shift_id: bookedSlot?.shift_id, full: false, campaign_id: bookedSlot?.campaign_id,
      }
    }
    dispatch(changeTimeSlotStatus(payload))
  }

  const validateFields = () => {
    return selectedDate?.value?.length > 1 && selectedShift?.id?.length > 1
  }

  return (
    <div>
      {loadingCampaignInfo || isEmpty(campaignInfo) || !isEmpty(campaignInfoError) || loadingShiftList || isEmpty(shiftList) || !isEmpty(shiftListError) ? (
        <JobCardLoader
          count={1}
          height="h-20"
          loading={loadingCampaignInfo || loadingShiftList}
          error={shiftListError || campaignInfoError}
          isEmpty={isEmpty(campaignInfo) || isEmpty(shiftList)}
          retry={() => {
            dispatch(getShifts(props.campaignId))
            dispatch(getCampaignInfo(props.campaignId))
          }}
        />
      ) : (
        <>
          <CustomMessage message="Add Date and Shift to end the shift if all time slots have been filled." className="mb-4" hasBackground={false}/>
          <div className="flex space-x-6 items-end">
            <LabeledSelect
              label="Shipping Date"
              getOptionLabel={(option) => option.value}
              onChange={(date) => {
                setSelectedDate(date)
                setSelectedShift(undefined)
              }}
              options={campaignInfo?.date
                ?.map(option => {
                  return {value: option}
                })}
              value={selectedDate}
            />

            <LabeledSelect
              label="Shift"
              placeholder={selectedDate.length === 0 ? 'Please select a date first' : 'Select...'}
              onChange={(slot) => {
                setSelectedShift(slot)
              }}
              getOptionValue={(option) => option?.id}
              getOptionLabel={(option) => `${option?.name} [${utcToLocalTimeString(option?.start_time)}-${utcToLocalTimeString(option?.end_time)}]`}
              options={selectedDate.length === 0 ? [] : differenceWith(shiftList, disabledShift, (shif, bookshif) => shif?.id === bookshif?.shift && selectedDate.value === bookshif.date,)}
              value={selectedShift}
            />
            <CustomButton disabled={!validateFields()} className="mb-3.5" onClick={() => onSlotBook(true)}>
              Add
            </CustomButton>
          </div>
          <div className="mb-2 flex space-x-2">
            <FormLabel className="mt-1.5" label="Filled Shifts:"/>
            {isEmpty(disabledShift) &&
              <div className="text-sm mt-1.5">Empty</div>
            }
            <div className="grow flex flex-wrap">
              {disabledShift?.map((bookShift) => {
                return (<Chip key={bookShift?.id} onClick={() => {
                  onSlotBook(false, bookShift)
                }}>
                  <div className="mr-1">{bookShift?.date} ({shiftList.find((shift) => shift?.id === bookShift?.shift_id,)?.name}) </div>
                </Chip>)
              })}
            </div>
          </div>
        </>
      )
      }
    </div>
  )
}

export default BookTimeSlot;
